import { Documents } from "@widgets/documents";
import { FC } from "react";

export const DocumentsPage: FC = () => {
  return <Documents />;
};
